import { TickerType } from 'services/client/getTickerList';

export interface TickerDetailsInfo {
  name: string;
  sector: string;
}

export function buildTickerDetailsMap(
  tickerData: TickerType[],
): Record<string, TickerDetailsInfo> {
  const map: Record<string, TickerDetailsInfo> = {};
  tickerData.forEach((td) => {
    map[td.t] = { name: td.n, sector: td.s };
  });
  return map;
}
